<template>
  <el-dialog
    id="cancellationPolicy"
    :visible.sync="showLocal"
    :width="dialogWidth"
    center
  >
    <div class="content">
      <div class="emphasize underLine">
        {{ $t('leader.coach.cancellationDoc.title') }}
      </div>
      <div>
        {{ $t('leader.coach.cancellationDoc.subtitle') }}
      </div>

      <div class="emphasize space">
        {{ $t('leader.coach.cancellationDoc.cancellation') }}:
      </div>

      <div class="space">
        {{ $t('leader.coach.cancellationDoc.cancellationCont') }}
      </div>

      <div class="emphasize space">
        {{ $t('leader.coach.cancellationDoc.lateAndNoShow') }}:
      </div>

      <div class="space">
        {{ $t('leader.coach.cancellationDoc.noShowCont') }}
      </div>

      <div class="space">
        <ul class="listGroup">
          <li
            v-for="index in 4"
            :key="`noShowDesc_${index}`"
          >
            {{ $t(`leader.coach.cancellationDoc.noShowDesc_${index}`) }}
          </li>
        </ul>
      </div>
    </div>

    <div class="buttonWrap">
      <el-checkbox
        v-model="is_agree"
        class="agreeCheckBox"
      >
        {{ $t('leader.coach.cancellationDoc.understandPolicy') }}
      </el-checkbox>
      <el-button
        type="primary"
        round
        :disabled="!is_agree"
        @click="agree"
      >
        {{ $t('common.submit') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import dialog from '@/mixins/dialog';

export default {
  mixins: [dialog],

  data: () => ({
    notShowAgain: false,
    is_agree: false,
  }),

  methods: {
    ...mapActions('user', [
      'policyAgreement',
    ]),

    async agree() {
      try {
        if (this.is_agree) {
          this.policyAgreement();
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.showLocal = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  #cancellationPolicy {
    .content {
      font-size: 14px;
      word-break: break-word;

      .emphasize {
        font-weight: bold;
      }

      .underLine {
        text-decoration: underline;
      }

      .space {
        margin: 10px 0;
      }

      .listGroup {
        li {
          margin: 10px 0;
        }
      }
    }

    .buttonWrap {
      padding: 5px 0 0;
      text-align: center;
      align-items: center;

      .el-checkbox {
        width: 100%;
        margin: 15px 0;
      }

      .el-button {
        width: 80%;
        max-width: 300px;
        min-width: 120px;
        padding: 13px 10px;
        word-break: break-word;
        white-space: normal;
        margin-top: 20px;
      }
    }
  }
</style>

<style lang="scss">
  #cancellationPolicy {
    .el-checkbox {
      .el-checkbox__label {
        word-break: break-word;
        white-space: normal;
        font-size: 18px;
      }
    }
  }
</style>
